import React from 'react';
import mobileLogo from '../../../media/img/vs-logo-blue.png';
import s from './MobileLogo.module.scss';

/**
 * MobileLogo component for authentication pages
 * Displays the ViewSpark logo only on mobile devices (hidden on desktop)
 */
export const MobileLogo: React.FC = () => (
  <div className="text-center d-md-none mt-4">
    <img src={mobileLogo} alt="ViewSpark" className={s.mobileLogo} />
  </div>
);

export default MobileLogo;